import { Box } from '@mui/material';

export const HealthGoalsIcon = () => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 20, height: 20, display: 'block', flexShrink: 0 }}
    aria-hidden
  >
    <ellipse opacity="0.5" cx="12" cy="18.5" rx="10" ry="3.5" fill="#20AEDC" />
    <path
      d="M12 1.25C12.4143 1.25 12.75 1.58579 12.75 2V3.03647L17.7578 5.54032L17.8118 5.56731C18.5462 5.93447 19.1723 6.24743 19.6079 6.55149C20.0497 6.85982 20.5141 7.3075 20.5141 8C20.5141 8.6925 20.0497 9.14018 19.6079 9.44851C19.1723 9.75257 18.5462 10.0655 17.8118 10.4327L12.75 12.9635V18C12.75 18.4142 12.4143 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V12.5162C11.2498 12.5058 11.2498 12.4953 11.25 12.4849V3.51509C11.2498 3.50466 11.2498 3.49421 11.25 3.48375V2C11.25 1.58579 11.5858 1.25 12 1.25Z"
      fill="#20AEDC"
    />
  </Box>
);

export const QuestionnaireIcon = () => (
  <Box
    component="svg"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 18, height: 18, display: 'block', flexShrink: 0 }}
    aria-hidden
  >
    <path
      d="M16.5 9H13.5L11.25 15.75L6.75 2.25L4.5 9H1.5"
      stroke="#20AEDC"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const QuestionnaireProgressIcon = () => (
  <Box
    component="svg"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 14, height: 14, display: 'block', flexShrink: 0 }}
    aria-hidden
  >
    <path
      opacity="0.5"
      d="M5.59562 1.86717C5.45358 1.98822 5.38256 2.04875 5.3067 2.09959C5.13281 2.21614 4.93752 2.29703 4.73214 2.33758C4.64255 2.35527 4.54952 2.36269 4.36346 2.37754L4.36346 2.37754C3.89599 2.41485 3.66225 2.4335 3.46724 2.50238C3.01621 2.66169 2.66144 3.01646 2.50213 3.46749C2.43325 3.66249 2.4146 3.89623 2.3773 4.3637L2.3773 4.36371C2.36245 4.54976 2.35502 4.64279 2.33734 4.73238C2.29679 4.93776 2.2159 5.13305 2.09935 5.30694C2.0485 5.3828 1.98797 5.45383 1.86691 5.59588L1.86691 5.59589C1.56273 5.95282 1.41064 6.13129 1.32146 6.31789C1.11518 6.74946 1.11518 7.25119 1.32146 7.68276C1.41064 7.86936 1.56273 8.04782 1.86691 8.40476L1.86692 8.40477C1.98796 8.54681 2.04851 8.61785 2.09935 8.69371C2.2159 8.8676 2.29679 9.06289 2.33734 9.26827C2.35502 9.35786 2.36245 9.45089 2.3773 9.63695C2.4146 10.1044 2.43325 10.3382 2.50213 10.5332C2.66144 10.9842 3.01621 11.339 3.46724 11.4983C3.66224 11.5672 3.89597 11.5858 4.36342 11.6231L4.36346 11.6231C4.54952 11.638 4.64255 11.6454 4.73214 11.6631C4.93752 11.7036 5.13281 11.7845 5.3067 11.9011C5.38256 11.9519 5.45359 12.0124 5.59564 12.1335L5.59565 12.1335C5.95258 12.4377 6.13105 12.5898 6.31764 12.679C6.74922 12.8852 7.25094 12.8852 7.68252 12.679C7.86911 12.5898 8.04758 12.4377 8.40451 12.1335L8.40453 12.1335C8.54658 12.0124 8.61761 11.9519 8.69346 11.9011C8.86736 11.7845 9.06265 11.7036 9.26802 11.6631C9.35762 11.6454 9.45065 11.638 9.6367 11.6231L9.63674 11.6231C10.1042 11.5858 10.3379 11.5672 10.5329 11.4983C10.984 11.339 11.3387 10.9842 11.498 10.5332C11.5669 10.3382 11.5856 10.1044 11.6229 9.63698L11.6229 9.63695C11.6377 9.45089 11.6451 9.35786 11.6628 9.26827C11.7034 9.06289 11.7843 8.8676 11.9008 8.69371C11.9517 8.61785 12.0122 8.54682 12.1333 8.40476C12.4374 8.04782 12.5895 7.86936 12.6787 7.68276C12.885 7.25119 12.885 6.74947 12.6787 6.31789C12.5895 6.13129 12.4374 5.95283 12.1333 5.59589L12.1332 5.59588C12.0122 5.45383 11.9517 5.3828 11.9008 5.30694C11.7843 5.13305 11.7034 4.93776 11.6628 4.73238C11.6451 4.64279 11.6377 4.54976 11.6229 4.36371L11.6229 4.36367C11.5856 3.89622 11.5669 3.66249 11.498 3.46749C11.3387 3.01646 10.984 2.66169 10.5329 2.50238C10.3379 2.4335 10.1042 2.41484 9.6367 2.37754C9.45065 2.36269 9.35762 2.35527 9.26802 2.33758C9.06265 2.29703 8.86736 2.21614 8.69346 2.09959C8.6176 2.04874 8.54657 1.98821 8.40451 1.86715C8.04758 1.56297 7.86911 1.41089 7.68252 1.3217C7.25094 1.11542 6.74922 1.11542 6.31764 1.3217C6.13105 1.41089 5.95258 1.56298 5.59565 1.86715L5.59562 1.86717Z"
      fill="#009966"
    />
    <path
      d="M9.55275 5.75381C9.73815 5.56841 9.73815 5.26781 9.55275 5.08241C9.36734 4.89701 9.06675 4.89701 8.88135 5.08241L6.05204 7.91172L5.12173 6.98142C4.93633 6.79602 4.63573 6.79602 4.45033 6.98142C4.26493 7.16682 4.26493 7.46742 4.45033 7.65282L5.71634 8.91882C5.90174 9.10422 6.20233 9.10422 6.38774 8.91882L9.55275 5.75381Z"
      fill="#009966"
    />
  </Box>
);

export const NextAppointmentIcon = () => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 20, height: 20, display: 'block', flexShrink: 0 }}
    aria-hidden
  >
    <circle cx="12" cy="6" r="4" fill="#1498CA" />
    <ellipse opacity="0.55" cx="12" cy="17" rx="7" ry="4.4" fill="#58BFD9" />
  </Box>
);
